import dayjs from 'dayjs';
import {
  toUpdatedByString,
  toUpdatedOnString,
} from '../../apis/reconAuditApi';

/** Oracle API field names (uppercase). DataGrid columns use these as field. */
export const API_FIELDS = {
  COMPANY: 'COMPANY',
  RECON_ID: 'RECON_ID',
  ORDER_NUM: 'ORDER_NUM',
  SUB_ORDER_NUM: 'SUB_ORDER_NUM',
  ITEM_NUMBER: 'ITEM_NUMBER',
  TRACKING_NUM: 'TRACKING_NUM',
  HIBBERT_DELIVERY_DATE: 'HIBBERT_DELIVERY_DATE',
  VEEVA_DELIVERY_DATE: 'VEEVA_DELIVERY_DATE',
  HIB_AOC_STATUS: 'HIB_AOC_STATUS',
  VEEVA_AOC_STATUS: 'VEEVA_AOC_STATUS',
  RECON_STATUS: 'RECON_STATUS',
  VEEVA_ORD_IDENTIFIER: 'VEEVA_ORD_IDENTIFIER',
  VEEVA_AOC_IDENTIFER: 'VEEVA_AOC_IDENTIFER',
  COMMENTS: 'COMMENTS',
  PCR_NUM: 'PCR_NUM',
  UPDATED_BY: 'UPDATED_BY',
  UPDATED_ON: 'UPDATED_ON',
  ACTIVE_FLAG: 'ACTIVE_FLAG',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
};

/** Recon Status dropdown options (label and value match). */
export const RECON_STATUS_OPTIONS = [
  'Status Mismatch',
  'Missing Delivery Date',
  'SRF Hold',
];

/** Normalize API row (snake_case or camelCase) to uppercase keys for DataGrid field mapping. */
export function toOracleRow(row) {
  const r = row;
  const get = (snake, camel) => {
    const v = r[snake] ?? r[camel ?? ''] ?? r[(camel ?? snake).toUpperCase()];
    return v ?? null;
  };
  return {
    [API_FIELDS.RECON_ID]: get('recon_id', 'reconId') ?? null,
    [API_FIELDS.COMPANY]: get('company') ?? null,
    [API_FIELDS.ORDER_NUM]: get('order_num', 'orderNum') ?? null,
    [API_FIELDS.SUB_ORDER_NUM]: get('sub_order_num', 'subOrderNum') ?? null,
    [API_FIELDS.ITEM_NUMBER]: get('item_number', 'itemNumber') ?? null,
    [API_FIELDS.TRACKING_NUM]: get('tracking_num', 'trackingNum') ?? null,
    [API_FIELDS.HIBBERT_DELIVERY_DATE]:
      get('hibbert_delivery_date', 'hibbertDeliveryDate') ?? null,
    [API_FIELDS.VEEVA_DELIVERY_DATE]:
      get('veeva_delivery_date', 'veevaDeliveryDate') ?? null,
    [API_FIELDS.HIB_AOC_STATUS]:
      get('hib_aoc_status', 'hibAocStatus') ?? null,
    [API_FIELDS.VEEVA_AOC_STATUS]:
      get('veeva_aoc_status', 'veevaAocStatus') ?? null,
    [API_FIELDS.RECON_STATUS]:
      get('recon_status', 'reconStatus') ?? null,
    [API_FIELDS.VEEVA_ORD_IDENTIFIER]:
      get('veeva_ord_identifier', 'veevaOrdIdentifier') ?? null,
    [API_FIELDS.VEEVA_AOC_IDENTIFER]:
      get('veeva_aoc_identifer', 'veevaAocIdentifer') ?? null,
    [API_FIELDS.COMMENTS]: get('comments') ?? null,
    [API_FIELDS.PCR_NUM]: get('pcr_num', 'pcrNum') ?? null,
    [API_FIELDS.UPDATED_BY]: toUpdatedByString(
      get('updated_by', 'updatedBy')
    ),
    [API_FIELDS.UPDATED_ON]: toUpdatedOnString(
      get('updated_on', 'updatedOn')
    ),
    [API_FIELDS.ACTIVE_FLAG]:
      get('active_flag', 'activeFlag') ?? null,
    [API_FIELDS.PENDING_APPROVAL]:
      get('pending_approval', 'pendingApproval') ?? null,
  };
}

export function formatUpdatedOn(value) {
  if (value == null || value === '') return '';
  const s = String(value);
  const d = dayjs(s);
  return d.isValid() ? d.format('YYYY-MM-DD HH:mm') : s;
}

/** Format date as MM/DD/YYYY; blank for null/empty/invalid. Uses date portion only. */
export function formatDateMMDDYYYY(value) {
  if (value == null || value === '') return '';
  const s = String(value).trim().slice(0, 10);
  if (!s) return '';
  const d = dayjs(s);
  return d.isValid() ? d.format('MM/DD/YYYY') : '';
}
